import React from "react";
import ShopType from "@/enum/ShopType";
import OrderDTO from "@/dto/order/OrderDTO";
import WithPopoverTip, { getRealBuyerNickName } from "./WithPopoverTip";

import AlibabaBuyerUsername from "./platform/AlibabaBuyerUsername";
import TaobaoBuyerUsername from "./platform/TaobaoBuyerUsername";
import PddBuyerUsername from "./platform/PddBuyerUsername";
import DouDianBuyerUsername from "./platform/DouDianBuyerUsername";
import ManualBuyerUsername from "./platform/ManualBuyerUsername";
import XhsBuyerUsername from "./platform/XhsBuyerUsername";
import { observer } from "mobx-react-lite";

interface BuyerUsernameProps {
    order: OrderDTO;
    shopType: ShopType;
    onSearch: () => void;
}

const BuyerUsername: React.FC<BuyerUsernameProps> = observer(({ order, shopType, onSearch }) => {
    if (shopType === ShopType.ALIBABA) {
        return <AlibabaBuyerUsername order={order} onSearch={onSearch} />;
    }

    if (shopType === ShopType.TAOBAO || shopType === ShopType.TAOBAO_DISTRIBUTION) {
        return <TaobaoBuyerUsername order={order} onSearch={onSearch} />;
    }

    if (shopType === ShopType.PINDUODUO) {
        return <PddBuyerUsername order={order} onSearch={onSearch} />;
    }

    if (shopType === ShopType.DOUDIAN) {
        return <DouDianBuyerUsername order={order} onSearch={onSearch} />;
    }

    if (shopType === ShopType.XIAOHONGSHU) {
        return <XhsBuyerUsername order={order} onSearch={onSearch} />;
    }

    if (shopType === ShopType.MANUAL) {
        return <ManualBuyerUsername order={order} onSearch={onSearch} />;
    }

    return <WithPopoverTip onSearch={onSearch}>{getRealBuyerNickName(order)}</WithPopoverTip>;
});

export default BuyerUsername;
